// extracted by mini-css-extract-plugin
export var additionaData = "PostCard-module--additionaData--3eda7";
export var articleCard = "PostCard-module--articleCard--e9439";
export var date = "PostCard-module--date--84ef5";
export var excerpt = "PostCard-module--excerpt--a64ab";
export var imgWrapp = "PostCard-module--imgWrapp--2976e";
export var link = "PostCard-module--link--88deb";
export var readMore = "PostCard-module--readMore--f6ae0";
export var showReadMore = "PostCard-module--showReadMore--bce89";
export var tag = "PostCard-module--tag--06c59";
export var timeToRead = "PostCard-module--timeToRead--a51cb";
export var title = "PostCard-module--title--47057";